import type { TourStep } from './types';

export const productsSteps: TourStep[] = [
  {
    target: 'body',
    title: 'Добро пожаловать в раздел "Товары"',
    content: 'Здесь вы можете управлять всеми товарами вашего каталога: просматривать, редактировать, фильтровать и экспортировать данные. Давайте познакомимся с основными функциями!',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="products-search"]',
    title: 'Поиск товаров',
    content: 'Используйте поле поиска для быстрого нахождения товаров по артикулу, названию или баркоду. Поиск работает в реальном времени.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="products-filter-category"]',
    title: 'Фильтр по категории',
    content: 'Выберите категорию, чтобы отобразить только товары из неё. Это поможет быстро найти нужные товары в большом каталоге.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="products-filter-status"]',
    title: 'Фильтр по статусу',
    content: 'Фильтруйте товары по статусу: "Все товары", "Готовые к выгрузке", "Есть замечания", "Невыгруженные на WB".',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="products-bulk-actions"]',
    title: 'Действия',
    content: 'Меню с действиями: импорт, экспорт, массовые операции. После выбора товаров появятся дополнительные действия.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="products-create-btn"]',
    title: 'Создание товара',
    content: 'Нажмите эту кнопку, чтобы добавить новый товар в каталог. Откроется форма для заполнения всех необходимых данных.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="products-table"]',
    title: 'Таблица товаров',
    content: 'Здесь отображается список всех товаров. Кликните на заголовок колонки для сортировки. Кликните на строку для просмотра подробной информации.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour="products-checkbox"]',
    title: 'Выбор товаров',
    content: 'Используйте чекбоксы для выбора нескольких товаров одновременно. Затем вы сможете выполнить массовые действия.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="products-pagination"]',
    title: 'Навигация по страницам',
    content: 'Используйте пагинацию для перемещения между страницами товаров.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour="products-items-per-page"]',
    title: 'Количество на странице',
    content: 'Выберите, сколько товаров отображать на одной странице: 100, 250, 500 или 1000.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: 'body',
    title: 'Отлично! Вы готовы к работе',
    content: 'Теперь вы знаете основные функции раздела "Товары". Для просмотра подробностей товара просто кликните на него в таблице. Удачной работы!',
    placement: 'center',
    disableBeacon: true,
  },
];
